import 'slick-carousel';

export default ($container) => {
    $('.js-usp-slider', $container).slick({
        rows:         0,
        autoplay:     true,
        arrows:       false,
        slidesToShow: 4,
        responsive:   [
            {
                breakpoint: 992,
                settings:   {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings:   {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $('.js-usp-section', $container).slick({
        rows:         0,
        infinite:     false,
        slidesToShow: 5,
        responsive:   [
            {
                breakpoint: 1200,
                settings:   {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 992,
                settings:   {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings:   {
                    arrows:       false,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 576,
                settings:   {
                    arrows:       false,
                    slidesToShow: 1,
                },
            },
        ],
    });
    $('.js-usp-block', $container).each(function() {
        const uspCount = $('.usp-block__slider-slide', this).length;
        $(this).slick({
            rows:         0,
            infinite:     false,
            slidesToShow: Math.min(5, uspCount),
            responsive:   [
                {
                    breakpoint: 1200,
                    settings:   {
                        slidesToShow: Math.min(4, uspCount),
                    },
                },
                {
                    breakpoint: 992,
                    settings:   {
                        slidesToShow: Math.min(3, uspCount),
                    },
                },
                {
                    breakpoint: 768,
                    settings:   {
                        arrows:       false,
                        slidesToShow: Math.min(2, uspCount),
                    },
                },
                {
                    breakpoint: 576,
                    settings:   {
                        arrows:       false,
                        slidesToShow: 1,
                    },
                },
            ],
        });
    })
};
